import {Path} from "react-hook-form";

import {CheckboxControlled} from "@pg-design/rhf-components-module";

import {validationMessages} from "../../form/utils/validation_messages";
import type {IConsentTemplate} from "../types";
import {getConsentContent} from "../utils/get_consent_content";

interface IProps {
    template: IConsentTemplate;
    className?: string;
}

export function ConsentCheckboxField<FormValues extends Record<"consents", Record<string, boolean>>>({template, className}: IProps) {
    return (
        <div className={className}>
            <CheckboxControlled<FormValues>
                name={`consents.${template.ulid}` as Path<FormValues>}
                labelContent={getConsentContent(template)}
                rules={template.consent_mode === "required" ? {required: validationMessages.required} : undefined}
            />
        </div>
    );
}
import {Path} from "react-hook-form";

import {CheckboxControlled} from "@pg-design/rhf-components-module";

import {validationMessages} from "../../form/utils/validation_messages";
import type {IConsentTemplate} from "../types";
import {getConsentContent} from "../utils/get_consent_content";

interface IProps {
    template: IConsentTemplate;
    className?: string;
}

export function ConsentCheckboxField<FormValues extends Record<"consents", Record<string, boolean>>>({template, className}: IProps) {
    return (
        <div className={className}>
            <CheckboxControlled<FormValues>
                name={`consents.${template.ulid}` as Path<FormValues>}
                labelContent={getConsentContent(template)}
                rules={template.consent_mode === "required" ? {required: validationMessages.required} : undefined}
            />
        </div>
    );
}
